import Settings from "@mui/icons-material/Settings";

import { makeSvgIcon } from "./svg-icon";

export const GemdSearchSpaceIcon = makeSvgIcon(
  Settings,
  (theme) => theme.palette.design.main,
);

export default GemdSearchSpaceIcon;
